import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	atlas: {
		id: 'dynamic-cards-search-page.products.atlas',
		defaultMessage: 'Atlas',
		description: 'Product name for Atlas 3p app option in the "Build Dynamic Cards" modal that opens when the user clicks the "View current filters" button in a dynamic cards configuration panel',
	},
	webPage: {
		id: 'dynamic-cards-search-page.products.custom-website',
		defaultMessage: 'Web page',
		description: 'display name for Web page 3p app option in the "Build Dynamic Cards" modal that opens when the user clicks the "View current filters" button in a dynamic cards configuration panel',
	},
	webPages: {
		id: 'dynamic-cards-search-page.products.custom-websites',
		defaultMessage: 'Web pages',
		description: 'display name for the pluralized Web pages 3p app option in the "Build Dynamic Cards" modal that opens when the user clicks the "View current filters" button in a dynamic cards configuration panel',
	},
	project: {
		id: 'dynamic-cards-search-page.nouns.project',
		defaultMessage: 'Project',
		description: 'display name for Project app option in the "Build Dynamic Cards" modal that opens when the user clicks the "View current filters" button in a dynamic cards configuration panel',
	},
	projects: {
		id: 'dynamic-cards-search-page.nouns.projects',
		defaultMessage: 'Projects',
		description: 'display name for pluralized Projects app option in the "Build Dynamic Cards" modal that opens when the user clicks the "View current filters" button in a dynamic cards configuration panel',
	},
	goal: {
		id: 'dynamic-cards-search-page.nouns.goal',
		defaultMessage: 'Goal',
		description: 'display name for Goal 3p app option in the "Build Dynamic Cards" modal that opens when the user clicks the "View current filters" button in a dynamic cards configuration panel',
	},
	goals: {
		id: 'dynamic-cards-search-page.nouns.goals',
		defaultMessage: 'Goals',
		description: 'display name for pluralized Goals 3p app option in the "Build Dynamic Cards" modal that opens when the user clicks the "View current filters" button in a dynamic cards configuration panel',
	},
	tag: {
		id: 'dynamic-cards-search-page.nouns.tag',
		defaultMessage: 'Tag',
		description: 'display name for Tag 3p app option in the "Build Dynamic Cards" modal that opens when the user clicks the "View current filters" button in a dynamic cards configuration panel',
	},
	tags: {
		id: 'dynamic-cards-search-page.nouns.tags',
		defaultMessage: 'Tags',
		description: 'display name for pluralized Tags 3p app option in the "Build Dynamic Cards" modal that opens when the user clicks the "View current filters" button in a dynamic cards configuration panel',
	},
});
